import { cn } from '@app/utils/cn';

interface WrapperProps {
  className?: string;
  dataTestId?: string;
  status?: 'warning';
}

export const SectionCard = ({ className, children, status }: React.WithChildren<WrapperProps>) => {
  return (
    <div className={cn('relative overflow-hidden rounded-regular bg-neutral-96/85 p-5', className)}>
      <div className={cn('absolute left-0 right-0 top-0 h-0.5 bg-neutral-20', { 'bg-warning-48': status === 'warning' })} />
      {children}
    </div>
  );
};
